import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { IDashboard } from 'src/app/pages/dashboard/models/dashboard';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { DashboardsService } from '../../services/dashboards.service';

@Component({
  selector: 'app-my-dashboard-list',
  templateUrl: './my-dashboard-list.component.html',
  styleUrls: ['./my-dashboard-list.component.scss']
})
export class MyDashbordListComponent {
  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();

  @Input() dashboards: IDashboard[] = [];
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };
  
  showModalEdit = false;
  editDashboard!: IDashboard;

  constructor(private readonly dashboardsService: DashboardsService, private readonly toastService: ToastService){}

  edit(dashboard: IDashboard): void {
    this.showModalEdit = true;
    this.editDashboard = dashboard;
  }

  inativarDashboard(id: string): void {
    this.dashboardsService.inativarDashboard(id).subscribe((res) => {
      if (res.messages && res.messages.length > 0) {
        this.toastService.toast(res.messages);
      }

      if (res.isSucceed) {
        this.recarregarListagem.emit();
      }
    });
  }

  ativarDashboard(id: string): void {
    this.dashboardsService.ativarDashboard(id).subscribe((res) => {
      if (res.messages && res.messages.length > 0) {
        this.toastService.toast(res.messages);
      }

      if (res.isSucceed) {
        this.recarregarListagem.emit();
      }
    });
  }
}
